/** @format */

import { CurrencyPipe, NgIfContext } from "@angular/common";
import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	TemplateRef,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { CountryISO, SearchCountryField } from "ngx-intl-tel-input";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { MDABillDto } from "src/app/Module/Main/search-mda-bill-history/search-mda-bill-history.component";
import { ApiServiceService } from "src/app/Services/api-service.service";
import { AuthService } from "src/app/Services/auth.service";
import { Utils } from "src/app/Shared/utils";
import { ErrorDialogComponent } from "src/app/Shared/shared/error-dialog/error-dialog.component";
import { HttpHeaders } from "@angular/common/http";
import alertify from "alertifyjs";
import { PublicPaymentModalComponent } from "src/app/Module/Main/public-payment-modal/public-payment-modal.component";
import { environment } from "src/environments/environment";
import { Location } from "@angular/common";
import { log } from "node:console";

@Component({
	selector: "app-mda-generate-bills-modal",
	templateUrl: "./mda-generate-bills-modal.component.html",
	styleUrls: ["./mda-generate-bills-modal.component.css"],
})
export class MdaGenerateBillsModalComponent implements OnInit, OnDestroy {
	confirm = new EventEmitter();
	@Input() asinDetails: any;
	@Input() asin: any;
	@Input() actor: any = "ADMIN";

	// ... all your properties (copied from original)
	minDate: any;
	preferredCountries: string[] = ["ng", "us", "gb"];
	countryISO: CountryISO = CountryISO.Nigeria;
	protected readonly SearchCountryField = SearchCountryField;
	numbersOnly = Utils.numberOnly;
	form: FormGroup;
	mdaForm: FormGroup;
	hasPayerData = false;
	mda: any;
	revenueCode: string;
	revenueName: string;
	serviceType: string;
	assessmentSearchForm: any = FormGroup;
	transactionType: string;
	showVariable: boolean;
	showPeriodIsApplicable: boolean;
	showLocationIsApplicable: boolean;
	showUploadsIsApplicable: boolean;
	showLandParamIsApplicable: boolean;
	lgas: any[] = [];
	areas: any[] = [];
	onPreview: boolean = false;
	uploaded: string = "";
	safePdfUrl: any = null;
	selecteMdaName: string = "";
	selectedYear: string = "";
	pdfUrl: string | ArrayBuffer | null = null;
	canvas: HTMLCanvasElement | null = null;
	isFormReadonly: boolean;
	selectedLgaName: any;
	selectedAreaName: any;
	selectedPeriod: string;
	dto: MDABillDto;
	submitting: boolean;
	loading: TemplateRef<NgIfContext<any[]>>;
	onConfirmClicked: any;
	selectedFileName: string;

	mdas: any[] = [];
	mdaList: any[] = [];
	showCustom: boolean;
	mdaCustomDetailsList: any[] = [];
	mdaCustomUploadablesList: any[] = [];
	customType: any;

	customSubTypes: string[] = ["REGISTRATION", "RENEWAL"];
	showRegistrationAndRenewal: boolean;

	selectedUploadableId: number | null = null;
	uploadedFiles: { id: number; name: string; file: String; upload: File }[] =
		[];
	uploadedIds: number[] = [];

	private destroy$ = new Subject<void>();
	customIdName: any;

	constructor(
		private location: Location,
		private fb: FormBuilder,
		private apiService: ApiServiceService,
		private authService: AuthService,
		private bsModalService: BsModalService,
		private currencyPipe: CurrencyPipe,
		private modalService: BsModalService,
		private ngbModal: NgbModal,
		private bsModalRef: BsModalRef,
	) {
		this.assessmentSearchForm = this.fb.group({
			paymentStatus: [""],
			invoice: [""],
			from: [""],
			to: [""],
			asin: [""],
			offset: [""],
		});
	}

	ngOnInit(): void {
		this.initializeForm();

		if (this.asinDetails) {
			this.hasPayerData = true;
			this.form.patchValue({
				name: this.asinDetails?.displayname,
				asin: this.asin,
				phoneNumber: this.asinDetails?.phoneNumber,
				email: this.asinDetails?.email,
			});

			this.disableFormFieldsWithValues(this.form, [
				"name",
				"asin",
				"email",
				"phoneNumber",
			]);

			this.getLgas();
		}
		if (this.actor === "ADMIN") {
			let mdaId = this.authService?.getDept();
			this.fetchMDADetails(mdaId);
		} else {
			this.fetchMDAs();
		}

		this.onRevenueNameSelected();
		this.onCustomSelected();
		this.updatePaymentAmount();

		this.mdaForm
			.get("mda")
			?.valueChanges.pipe(takeUntil(this.destroy$))
			.subscribe((selectedId) => {
				this.updateSelectedMdaName(selectedId);
			});

		this.mdaForm
			.get("paymentPeriod")
			?.valueChanges.pipe(takeUntil(this.destroy$))
			.subscribe((value) => {
				this.selectedYear = this.extractYear(value);
			});

		this.mdaForm
			.get("period")
			?.valueChanges.pipe(takeUntil(this.destroy$))
			.subscribe((value) => {
				this.selectedPeriod = this.extractYear(value);
			});

		this.mdaForm
			.get("lga")
			?.valueChanges.pipe(takeUntil(this.destroy$))
			.subscribe((value) => {
				this.updateSelectedLgaName();
			});

		this.mdaForm
			.get("area")
			?.valueChanges.pipe(takeUntil(this.destroy$))
			.subscribe((value) => {
				this.updateSelectedAreaName();
			});

		this.mdaForm
			.get("mdaId")
			?.valueChanges.pipe(takeUntil(this.destroy$))
			.subscribe((value) => {
				console.log("value ", value);
				if (value) {
					this.fetchMDADetails(value);
				}
			});
	}

	fetchMDAs(): void {
		// const url = "/assessments/mdas/list"; all
		const url = "/assessments/mdas/list/all"; // all configured
		this.apiService.get(url).subscribe(
			(response) => {
				this.mdas = response;
			},
			(error) => {
				console.error("Error fetching MDA list:", error);
			},
		);
	}

	// ---------- UPLOAD HANDLERS (unchanged, only small guards) ----------
	onEachUploadChange(event: Event): void {
		const fileInput = event.target as HTMLInputElement;

		this.uploaded = null;
		this.pdfUrl = null;

		const file = fileInput.files?.[0];
		if (!file || !this.selectedUploadableId) return;

		const maxFileSize = 1048576;
		if (file.size > maxFileSize) {
			fileInput.value = "";
			alertify.error("File size should not exceed 1MB.");
			return;
		}

		const selectedItem = this.mdaCustomUploadablesList.find(
			(x) => x.id === this.selectedUploadableId,
		);
		if (!selectedItem) return;

		const handleUpload = (base64: string) => {
			this.uploadedFiles.push({
				id: selectedItem.id,
				name: selectedItem.name,
				file: base64,
				upload: file,
			});
			this.uploadedIds.push(selectedItem.id);

			// Reset dropdown + file input
			this.selectedUploadableId = null;
			fileInput.value = "";

			// if upload control is used for a single file, we can set it too (not required)
			// this.mdaForm.patchValue({ upload: base64, fileName: file.name });
		};

		if (this.isFileImage(file)) {
			this.convertToBase64(file).then(handleUpload);
		} else if (this.isFilePDF(file)) {
			const reader = new FileReader();
			reader.onload = (e: any) => {
				this.pdfUrl = e.target.result;
				this.convertToBase64(file).then(handleUpload);
			};
			reader.readAsArrayBuffer(file);
		}
	}

	removeUploadedFile(index: number): void {
		const removed = this.uploadedFiles.splice(index, 1)[0];
		if (removed) {
			this.uploadedIds = this.uploadedIds.filter(
				(id) => id !== removed.id,
			);
		}
	}

	// ---------- helper getters / small utils ----------
	updateSelectedMdaName(mdaId: any) {
		const selectedMda = this.mdaList.find((mda) => mda.id == mdaId);
		this.selecteMdaName = selectedMda ? selectedMda.revenueName : "";
	}

	updateSelectedLgaName() {
		const selectedLgaId = this.mdaForm.get("lga")?.value;
		const selectedLga = this.lgas.find((lga) => lga.id == selectedLgaId);
		this.selectedLgaName = selectedLga ? selectedLga.name : "";
	}

	updateSelectedAreaName() {
		const selectedAreaId = this.mdaForm.get("area")?.value;
		const selectedArea = this.areas.find(
			(area) => area.id == selectedAreaId,
		);
		this.selectedAreaName = selectedArea ? selectedArea.name : "";
	}

	extractYear(value: any): string {
		if (!value) return "";
		const date = new Date(value);
		return isNaN(date.getTime()) ? "" : date.getFullYear().toString();
	}

	// onUploadChange kept (unchanged)
	onUploadChange(event: Event): void {
		const fileInput = event.target as HTMLInputElement;
		this.uploaded = null;
		this.pdfUrl = null;
		const file = fileInput.files?.[0];
		if (!file) return;

		const maxFileSize = 1048576;
		if (file.size > maxFileSize) {
			fileInput.value = "";
			alertify.error("File size should not exceed 1MB.");
			return;
		}

		this.selectedFileName = file.name;

		if (this.isFileImage(file)) {
			this.convertToBase64(file).then((base64) => {
				this.uploaded = base64;
				this.mdaForm.patchValue({
					upload: base64,
					fileName: file.name,
				});
				const pdfContainer = document.getElementById("pdf-container");
				if (pdfContainer) pdfContainer.innerHTML = "";
			});
		} else if (this.isFilePDF(file)) {
			const reader = new FileReader();
			reader.onload = (e: any) => {
				this.pdfUrl = e.target.result;
				this.convertToBase64(file).then((base64) => {
					this.mdaForm.patchValue({
						upload: base64,
						fileName: file.name,
					});
				});
			};
			reader.readAsArrayBuffer(file);
		}
	}

	isImage(documentUpload: any): boolean {
		return (
			typeof documentUpload === "string" &&
			documentUpload.startsWith("data:image/")
		);
	}
	isFileImage(file: File): boolean {
		return file?.type?.startsWith("image/") ?? false;
	}
	isFilePDF(file: File): boolean {
		return file?.type === "application/pdf";
	}
	convertToBase64(file: File): Promise<string> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => resolve(reader.result as string);
			reader.onerror = (err) => reject(err);
			reader.readAsDataURL(file);
		});
	}

	confirmAfterError(message: any) {
		let dfModalRef = this.bsModalService.show(ErrorDialogComponent, {
			initialState: { body: message },
			class: "modal-sm modal-dialog-centered",
		});
		dfModalRef?.content?.onConfirmClicked.subscribe((v) =>
			dfModalRef.hide(),
		);
	}

	getLgas() {
		const url = "/auth/lga/all";
		this.apiService.LoginGet(url).subscribe(
			(response) => (this.lgas = response),
			(error) => console.log(error),
		);
	}

	getAreas() {
		const lgaId = this.mdaForm.get("lga")?.value;
		const url = `/auth/area/all/${lgaId}`;
		this.apiService.LoginGet(url).subscribe(
			(response) => (this.areas = response),
			(error) => console.log(error),
		);
	}

	fetchCustomDetails(id: number): void {
		const url = "/assessments/mda/custom/details/list?id=" + id;
		this.apiService.get(url).subscribe((res: any) => {
			this.mdaCustomDetailsList = res?.data || [];
		});
	}

	fetchCustomUploadables(id: number): void {
		const url = "/assessments/mda/custom/uploads/list?id=" + id;
		this.apiService.get(url).subscribe((res: any) => {
			this.mdaCustomUploadablesList = res?.data || [];
		});
	}

	// ---------- onCustomSelected: clears and sets validators appropriately ----------
	onCustomSelected() {
		// subscribe once, auto-unsubscribe with takeUntil
		this.mdaForm
			.get("mdaCustomId")
			?.valueChanges.pipe(takeUntil(this.destroy$))
			.subscribe((v) => {
				this.showVariable = false;
				this.customIdName = "";
				this.customType = "";
				this.showRegistrationAndRenewal = false;

				const customTypeControl = this.mdaForm.get("mdaCustomType");
				// reset control so previous value/validators don't leak
				customTypeControl?.reset();
				customTypeControl?.enable();
				customTypeControl?.clearValidators();
				customTypeControl?.setValidators([Validators.required]);
				customTypeControl?.updateValueAndValidity();

				const paymentControl = this.mdaForm.get("paymentAmountDue");
				paymentControl?.reset();
				paymentControl?.enable();
				paymentControl?.clearValidators();
				// we'll set validators depending on custom subtype
				paymentControl?.updateValueAndValidity();

				if (!v) return;

				const result = this.mdaCustomDetailsList.find(
					(x: any) => x?.id == v,
				);
				if (!result) return;

				this.customType = result?.serviceType;

				this.customIdName = result?.serviceName;

				if (result?.serviceType === "FIXED") {
					const amount = result?.amount;
					customTypeControl?.setValue(this.customType);
					customTypeControl?.disable();

					// fixed => paymentAmountDue required and prefilled and disabled
					paymentControl?.setValidators([Validators.required]);
					paymentControl?.setValue(amount != null ? amount : null);
					if (amount != null) {
						paymentControl?.patchValue(
							this.currencyPipe.transform(
								Number(amount).toFixed(2),
								"NGN",
								"symbol-narrow",
							),
						);
					}
					paymentControl?.updateValueAndValidity();
					this.disableFormFieldsWithValues(this.mdaForm, [
						"paymentAmountDue",
					]);
				}

				if (result?.serviceType === "REGISTRATION_AND_RENEWAL") {
					this.showRegistrationAndRenewal = true;

					// ensure we don't create multiple subscriptions on valueChanges:
					customTypeControl?.valueChanges
						.pipe(takeUntil(this.destroy$))
						.subscribe((subType) => {
							// set required on paymentAmountDue when subtype selected
							const pc = this.mdaForm.get("paymentAmountDue");
							pc?.clearValidators();
							if (
								subType === "REGISTRATION" &&
								result?.regAmount != null
							) {
								pc?.setValidators([Validators.required]);
								pc?.setValue(result?.regAmount);
							} else if (
								subType === "RENEWAL" &&
								result?.renewalAmount != null
							) {
								pc?.setValidators([Validators.required]);
								pc?.setValue(result?.renewalAmount);
							} else {
								pc?.setValue(null);
							}

							pc?.updateValueAndValidity();
							const value = parseFloat(pc?.value || 0);
							if (value) {
								pc?.patchValue(
									this.currencyPipe.transform(
										Number(value).toFixed(2),
										"NGN",
										"symbol-narrow",
									),
								);
							}
							this.disableFormFieldsWithValues(this.mdaForm, [
								"paymentAmountDue",
							]);
						});
				}
			});
	}

	// ---------- onRevenueNameSelected: centralised validator handling ----------
	onRevenueNameSelected() {
		this.mdaForm
			.get("mda")
			?.valueChanges.pipe(takeUntil(this.destroy$))
			.subscribe((v) => {
				this.showVariable = false;
				this.showCustom = false;

				// reset serviceType UI
				this.mdaForm.get("serviceType")?.setValue("");
				this.disableFormFieldsWithValues(this.mdaForm, ["serviceType"]);

				if (!v) return;

				const result = this.mdaList.find((x: any) => x?.id == v);
				if (!result) return;

				this.mda = this.mdaList;
				const amount = result?.amount;
				const serviceType = result?.type;

				this.serviceType = serviceType;
				this.revenueCode = result?.revenueCode;
				this.revenueName = result?.name;

				this.determineAdditionalQuestionsToShow(result);
				this.onPreview = false;

				// CLEAR validators + null out irrelevant control values so they don't block validation
				const conditionalControls = [
					"transactionAmount",
					"percentage",
					"mdaCustomId",
					"mdaCustomType",
					"paymentAmountDue",
					"lga",
					"area",
					"address",
					"landSize",
					"period",
					"upload",
				];
				conditionalControls.forEach((name) => {
					const ctrl = this.mdaForm.get(name);
					if (!ctrl) return;
					ctrl.clearValidators();
					ctrl.setValue(null); // important: remove empty strings
					ctrl.enable(); // enable so user can fill; will disable if value is fixed later
					ctrl.updateValueAndValidity({ emitEvent: false });
				});

				// Now set validators based on type
				if (serviceType === "VARIABLE") {
					this.showVariable = true;
					this.mdaForm
						.get("transactionAmount")
						?.setValidators([Validators.required]);
					this.mdaForm
						.get("percentage")
						?.setValidators([Validators.required]);
					this.mdaForm
						.get("transactionAmount")
						?.updateValueAndValidity();
					this.mdaForm.get("percentage")?.updateValueAndValidity();

					if (amount != null) {
						this.mdaForm.get("percentage")?.setValue(amount);
						this.disableFormFieldsWithValues(this.mdaForm, [
							"percentage",
						]);
					}
				} else if (serviceType === "CUSTOM") {
					this.showCustom = true;

					// Only require custom id/type. Other fields remain cleared/nullable unless custom selection sets them.
					this.mdaForm
						.get("mdaCustomId")
						?.setValidators([Validators.required]);
					this.mdaForm
						.get("mdaCustomType")
						?.setValidators([Validators.required]);
					this.mdaForm.get("mdaCustomId")?.updateValueAndValidity();
					this.mdaForm.get("mdaCustomType")?.updateValueAndValidity();

					// fetch custom metadata
					this.fetchCustomDetails(v);
					this.fetchCustomUploadables(v);

					// IMPORTANT: If this MDA requires uploads, we will enforce uploadedFiles length in setToReadonly()
				} else {
					// FIXED (or default) — require paymentAmountDue only
					this.mdaForm
						.get("paymentAmountDue")
						?.setValidators([Validators.required]);
					if (amount != null) {
						this.mdaForm.get("paymentAmountDue")?.setValue(amount);
						this.mdaForm
							.get("paymentAmountDue")
							?.patchValue(
								this.currencyPipe.transform(
									Number(amount).toFixed(2),
									"NGN",
									"symbol-narrow",
								),
							);
						this.disableFormFieldsWithValues(this.mdaForm, [
							"paymentAmountDue",
						]);
					}
					this.mdaForm
						.get("paymentAmountDue")
						?.updateValueAndValidity();
				}

				// set serviceType control and lock it visually (if you want)
				if (serviceType != null) {
					this.mdaForm.get("serviceType")?.setValue(serviceType);
					this.disableFormFieldsWithValues(this.mdaForm, [
						"serviceType",
					]);
				}
			});
	}

	determineAdditionalQuestionsToShow(result: any) {
		this.showPeriodIsApplicable = true;
		this.showLocationIsApplicable = true;
		this.showUploadsIsApplicable = true;
		this.showLandParamIsApplicable = true;

		if (!result?.periodIsApplicable) {
			this.showPeriodIsApplicable = false;
			this.mdaForm.get("period")?.clearValidators();
			this.mdaForm.get("period")?.updateValueAndValidity();
		}

		if (!result?.locationIsApplicable) {
			this.showLocationIsApplicable = false;
			this.mdaForm.get("lga")?.clearValidators();
			this.mdaForm.get("lga")?.updateValueAndValidity();
			this.mdaForm.get("area")?.clearValidators();
			this.mdaForm.get("area")?.updateValueAndValidity();
			this.mdaForm.get("address")?.clearValidators();
			this.mdaForm.get("address")?.updateValueAndValidity();
		}

		// For CUSTOM, if uploads not applicable clear upload validator; if applicable we'll validate uploadedFiles in setToReadonly()
		if (!result?.uploadsIsApplicable && this.serviceType == "CUSTOM") {
			this.showUploadsIsApplicable = false;
			this.mdaForm.get("upload")?.clearValidators();
			this.mdaForm.get("upload")?.updateValueAndValidity();
		}

		if (!result?.landParamIsApplicable) {
			this.showLandParamIsApplicable = false;
			this.mdaForm.get("landSize")?.clearValidators();
			this.mdaForm.get("landSize")?.updateValueAndValidity();
		}
	}

	updatePaymentAmount() {
		this.mdaForm
			.get("transactionAmount")
			.valueChanges.pipe(takeUntil(this.destroy$))
			.subscribe((v) => {
				if (this.serviceType == "VARIABLE") {
					if (this.mdaForm.get("transactionAmount")?.value) {
						let transactionAmount = this.mdaForm
							.get("transactionAmount")
							?.value.replace(/[^0-9.e+]/gi, "");
						let totalAmount =
							Number(transactionAmount) *
							(Number(this.mdaForm.get("percentage").value) /
								100);
						if (totalAmount) {
							this.mdaForm
								.get("paymentAmountDue")
								?.patchValue(
									this.currencyPipe.transform(
										totalAmount.toFixed(2),
										"NGN",
										"symbol-narrow",
									),
								);
						}
						this.disableFormFieldsWithValues(this.mdaForm, [
							"paymentAmountDue",
						]);
					}
				}
			});
	}

	now(): Date {
		return new Date();
	}
	get minDateValue(): any {
		return this.minDate;
	}

	initializeForm(): void {
		this.form = this.fb.group({
			name: [""],
			asin: ["", [Validators.required]],
			phoneNumber: [""],
			email: [""],
		});

		// Keep validators on controls initially; we'll remove irrelevant ones when a specific MDA is selected
		this.mdaForm = this.fb.group({
			mdaId: [null, [Validators.required]],
			mda: ["", [Validators.required]],
			serviceType: ["", [Validators.required]],
			paymentPeriod: ["", [Validators.required]],
			transactionDescription: ["", [Validators.required]],
			paymentAmountDue: ["", [Validators.required]],
			transactionAmount: ["", [Validators.required]],
			percentage: ["", [Validators.required]],
			lga: ["", [Validators.required]],
			area: ["", [Validators.required]],
			address: ["", [Validators.required]],
			landSize: [
				"",
				[
					Validators.required,
					Validators.min(1),
					Validators.pattern("^[0-9]*$"),
				],
			],
			period: ["", [Validators.required]],
			upload: ["", [Validators.required]],
			mdaCustomId: ["", [Validators.required]],
			mdaCustomType: ["", [Validators.required]],
		});
	}

	onUpload(event: Event): void {
		const input = event.target as HTMLInputElement;
		if (input.files?.length) {
			const file = input.files[0];
			this.mdaForm?.patchValue({ upload: file });
		}
	}

	disableFormFieldsWithValues(
		form: FormGroup,
		fieldsToDisable: string[],
	): void {
		fieldsToDisable.forEach((formControlName) => {
			const control = form?.get(formControlName);
			if (control && control.value) {
				control.disable();
			}
		});
	}

	fetchMDADetails(mdaId: any): void {
		const url = "/assessments/revenues/list/all?id=" + mdaId;
		this.apiService.get(url).subscribe((res: any[]) => {
			this.mdaList = res;
		});
	}

	setToReadonly() {
		this.mdaForm.markAllAsTouched();

		// if the MDA requires uploads, ensure at least one uploaded file
		const selectedMda = this.mdaList.find(
			(m) => m.id == this.mdaForm.get("mda")?.value,
		);

		console.log("mda form:: ", this.mdaForm.value);
		this.mdaForm.patchValue({ mdaId: selectedMda?.id });
		// basic validity
		if (!this.mdaForm.valid) {
			// debug which controls are invalid
			console.log("Invalid controls:");
			Object.keys(this.mdaForm.controls).forEach((key) => {
				const control = this.mdaForm.get(key);
				if (control && control.invalid) {
					console.log(key, control.errors);
				}
			});
			return;
		}

		// Additional CUSTOM checks
		if (this.mdaForm.get("serviceType")?.value === "CUSTOM") {
			// require custom selection
			if (!this.mdaForm.get("mdaCustomId")?.value) {
				alertify.error("Please select a custom service");
				return;
			}

			if (selectedMda?.uploadsIsApplicable) {
				if (!this.uploadedFiles || this.uploadedFiles.length === 0) {
					alertify.error("Please upload required documents");
					return;
				}
			}
		}

		// All good
		this.isFormReadonly = true;
	}

	setToEditable() {
		this.isFormReadonly = false;
	}

	createAndPay(): void {
		this.submitting = true;
		this.preview();

		const url = "/assessments/generate-mda-bill";
		this.dto.transactionAmount = this.dto.transactionAmount.replace(
			/[^0-9.e+]/gi,
			"",
		);
		const header = new HttpHeaders({ user: this.authService.getId() });

		this.apiService.post(url, this.dto, { header }).subscribe(
			(response) => {
				alertify.set("notifier", "position", "top-center");
				alertify.success("Bill generated successfully");
				setTimeout(() => this.saveAndPayOnline(this.dto), 2000);
			},
			(error) => {
				this.submitting = false;
				alertify.set("notifier", "position", "top-center");
				alertify.error("Error performing this operation");
			},
		);
	}

	saveAndPayOnline(data: MDABillDto) {
		const returnBackUrl = `${environment?.url}/payment/successful-payment`;
		const result = this.mda.find((x) => x?.id == data?.mdaId);
		const revenueCode = result?.revenueCode;
		const revenueId = result?.revenueId;
		const revenueName = result?.revenueName;

		let requestRemitaRRR = {
			returnBackUrl,
			totalAmount: data?.transactionAmount.replace(/[^0-9.e+]/gi, ""),
			fullName: data?.taxpayerDisplayName,
			customerId: data?.taxpayerAsin,
			revenueName: revenueName,
			revenueId: revenueCode,
			email: data?.taxpayerEmail,
			taxGroup: "INDIVIDUAL",
			phoneNumber: data?.taxpayerPhoneNumber,
			feeDescription: revenueName,
			entityName: revenueName,
			entityType: "MDA",
			entityGroup: data?.serviceType,
			accessedBy: this.authService.getDisplayName(),
			mdaRecordId: revenueId,
		};

		let bsModalRef = this.modalService.show(PublicPaymentModalComponent, {
			initialState: { details: requestRemitaRRR },
			backdrop: true,
			class: "modal-md modal-dialog-centered",
			ignoreBackdropClick: true,
		});

		bsModalRef?.content?.onConfirmClicked.subscribe((v) =>
			bsModalRef.hide(),
		);
	}

	preview(): void {
		this.dto = {
			taxpayerDisplayName: this.form.get("name")?.value,
			taxpayerAsin: this.form.get("asin")?.value,
			taxpayerEmail: this.form.get("email")?.value,
			taxpayerPhoneNumber:
				this.form.get("phoneNumber")?.value?.e164Number,
			mda: this.mdaForm?.get("mda")?.value,
			mdaId: this.mdaForm?.get("mdaId")?.value,
			paymentPeriod: this.mdaForm?.get("paymentPeriod")?.value,
			serviceType: this.mdaForm?.get("serviceType")?.value,
			transactionAmount: this.mdaForm?.get("paymentAmountDue")?.value,
			transactionDescription: this.mdaForm?.get("transactionDescription")
				?.value,
			revenueCode: this.revenueCode,
			revenueName: this.revenueName,
			lga: this.mdaForm.get("lga")?.value,
			area: this.mdaForm.get("area")?.value,
			address: this.mdaForm.get("address")?.value,
			landSize: this.mdaForm.get("landSize")?.value,
			period: this.mdaForm.get("period")?.value,
			upload: this.mdaForm.get("upload")?.value,
			customMDAUploadables: this.uploadedFiles,
			customMDADetailId: this.mdaForm.get("mdaCustomId")?.value,
			customMDAServiceType: this.mdaForm.get("mdaCustomType")?.value,
		};
	}

	create(): void {
		this.submitting = true;
		this.preview();
		const url = "/assessments/generate-mda-bill";
		this.dto.transactionAmount = this.dto.transactionAmount.replace(
			/[^0-9.e+]/gi,
			"",
		);
		const header = new HttpHeaders({ user: this.authService.getId() });

		this.apiService.post(url, this.dto).subscribe(
			(response) => {
				this.submitting = false;
				alertify.set("notifier", "position", "top-center");
				alertify.success("Bill generated successfully");
				setTimeout(() => window.location.reload(), 2000);
			},
			(error) => {
				this.submitting = false;
				alertify.set("notifier", "position", "top-center");
				alertify.error("Error performing this operation");
			},
		);
	}

	get currencySymbol(): string {
		return Utils.currencySymbol("NGN");
	}

	open(content: any) {
		this.ngbModal.open(content, { centered: true, size: "md" });
	}

	// small helper to clear validators
	private clearValidators(controlName: string) {
		const ctrl = this.mdaForm.get(controlName);
		if (!ctrl) return;
		ctrl.clearValidators();
		ctrl.updateValueAndValidity();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	close(data?: any) {
		this.bsModalRef.hide();
	}
}
